import {
	FEDERATED_CONNECTOR_SOURCE,
	type ThirdPartyConfigsBootstrap,
} from '../../constants/schemas/3p-config';

/**
 * Determines whether Slack is federated based on the connector sync type
 * from the third-party configuration API response.
 *
 * @param thirdPartyConfigs - Optional third party configs containing connector source info
 * @returns boolean - Whether the Slack connector is using federated sync
 */
export const isSlackFederatedByConnectorSyncType = (
	thirdPartyConfigs?: ThirdPartyConfigsBootstrap,
): boolean => {
	return thirdPartyConfigs?.slack?.connectorSources?.includes(FEDERATED_CONNECTOR_SOURCE) ?? false;
};
